import React, { Component } from 'react';
import { AuthStrategy } from '../../session';

class Logout extends Component {
  render() {
    return <AuthStrategy.LogoutComponent />;
  }
}

export default Logout;
